import { useNavigate } from "react-router-dom";
import { Button } from "@hydra/atom/components";

import dynamicObjectMap from "@/utils/maps/dynamicObjectMap";
import DynamicObjectOverview, { defaultComponents } from "@/pages/dynamic/list-views/DynamicObjectOverview";

function HeaderRightContent(props) {
  const navigate = useNavigate();
  return (
    <defaultComponents.HeaderRightContent {...props}>
      <Button small type="button" className="btn bordered" onClick={() => navigate("/finance/purchase-order/link-to-material-request")}>
        Link PO to MR
      </Button>
    </defaultComponents.HeaderRightContent>
  );
}

function PurchaseOrderOverview() {
  return (
    <DynamicObjectOverview
      objectName={dynamicObjectMap.get("PurchaseOrderObjectName")}
      components={{
        HeaderRightContent
      }}
      showFilters
    />
  );
}

export default PurchaseOrderOverview;
